<template>
  <div class="bread-crumb">
    <ul>
      <li>
        <a href="https://online.xueersi.com/select-course">选课中心</a>
      </li>
      <li>
        <router-link
          :to="{
            name: 'course-detail',
            params: { courseId: $route.params.courseId, classId: $route.params.classId }
          }"
          >课程详情</router-link
        >
      </li>
      <li>换购</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'bread-crumb',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
a {
  color: #afafaf;
}
a:hover {
  color: #666;
}
.bread-crumb {
  font-size: 12px;
  line-height: 16px;
  width: 1200px;
  height: 16px;
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  padding: 20px 0;
  li {
    float: left;
  }
  li + li:before {
    content: '>';
    color: #999999;
    width: 3px;
    height: 4px;
    padding: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/AddPurchase/components/NavigationBread.vue